var url=''
if (process.env.NODE_ENV === "development") {
    url='/api'
  }else {
      url=''
  }
  export default url



// WEBPACK FOOTER //
// ./src/utils/url.js